import { useState, useEffect } from "react";

interface IEdgePlayerTokenTimerProps {
  issuedAt: string;
  expiresAt: string;
  handleTokenExpired: () => void;
}

function EdgePlayerTokenTimer({ issuedAt, expiresAt, handleTokenExpired }: IEdgePlayerTokenTimerProps) {
  const tokenTime = Date.parse(expiresAt) - Date.parse(issuedAt);
  const [timeLeft, setTimeLeft] = useState(tokenTime);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    let timer: any;
    if (timeLeft <= 2000) {
      if (!redirect) {
        setRedirect(true);
        handleTokenExpired();
      }
    } else {
      timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1000);
      }, 1000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [timeLeft, redirect, setRedirect, setTimeLeft, handleTokenExpired]);

  return null;
}

export default EdgePlayerTokenTimer;
